export type BrowserNotification =
    | {
          type: "INCOMING_CALL";
          data: CallInfo;
      }
    | {
          type: "MISSED_CALL";
          data: CallInfo;
      }
    | {
          type: "INACTIVITY_TIMEOUT";
          data: {};
      }
    | {
          type: "MISSED_CALLS_RESET";
          data: {};
      };

export type CallInfo = {
    callerNumber: string;
    callerName: string;
    callType: "inbound" | "queue" | "internal";
    call: Record<string, any>;
};

export enum BrowserNotificationMessageType {
    INCOMING_CALL = "INCOMING_CALL",
    MISSED_CALL = "MISSED_CALL",
    INACTIVITY_TIMEOUT = "INACTIVITY_TIMEOUT",
    MISSED_CALLS_RESET = "MISSED_CALLS_RESET",
}
